import makeStyles from '@mui/styles/makeStyles';
import { gray1, textGrayH1 } from "../../DashStyleGuides";

export const useStyles = makeStyles({
  root: {
    height: "auto"
  },
  title: {
    margin: "20px 24px 10px 24px !important",
    fontSize: 14,
    fontWeight: 600,
    color: gray1
  },
  lblFigures: {
    fontSize: 36,
    fontWeight: 700,
    margin: "0px 24px 24px !important",
    color: textGrayH1
  }
});
